import {computed, ComputedRef} from "vue"

const screenType: ComputedRef<string> = computed(() => {
    return window.screenSizeManager.screenType;
})

export default screenType